import { create } from "zustand";
import { persist, createJSONStorage } from "zustand/middleware";
import axios from "axios";
import { toast } from "react-toastify";

export const useCartStore = create(
  persist(
    (set, get) => ({
      totalAmount: 0,
      toyUnitsQ: 0,
      cart: [],
      addToCart: async (toyId) => {
        const json = await axios(
          `https://rayuela.onrender.com/api/products/${toyId}`
        );
        const theToy = json.data;
        const { id, img, name, price } = theToy;
        let toyObject = {
          id: Number(id),
          img: img,
          name: name,
          price: Number(price),
          quantity: 1,
        };
        let cartItems = get().cart;
        let getToyUnitsQ = get().getToyUnitsQ;
        let getTotalAmount = get().getTotalAmount;
        for (let i = 0; i < cartItems.length; i++) {
          if (cartItems[i].id === toyObject.id) {
            let newQuantity = cartItems[i].quantity++;
            set({ cart: cartItems });
            getTotalAmount();
            getToyUnitsQ();
            toast.info(
              `${1 + newQuantity} ${toyObject.name} en el carrito de compras`,{
                position: "bottom-left"}
            );
            return;
          }
        }
        cartItems.push(toyObject);
        set({ cart: cartItems });
        getTotalAmount();
        getToyUnitsQ();
        toast.success(`${toyObject.name} agregado al carrito de compras`, {
          position: "bottom-left",
        });
        return;
      },
      getTotalAmount: () => {
        let cartItems = get().cart;
        let totalAmount = cartItems
          ?.map((item) => item.price * item.quantity)
          .reduce((x, y) => x + y, 0);
        return set({ totalAmount: totalAmount });
      },
      getToyUnitsQ: () => {
        let cartItems = get().cart;
        let toyUnitsQ = cartItems
          ?.map((item) => item.quantity)
          .reduce((x, y) => x + y, 0);
        return set({ toyUnitsQ: toyUnitsQ });
      },
      removeCartItem: (theToy) => {
        let cartItems = get().cart;
        let getTotalAmount = get().getTotalAmount;
        let getToyUnitsQ = get().getToyUnitsQ;
        let filteredCart = cartItems.filter((item) => {
          return theToy.id !== item.id;
        });

        set({ cart: filteredCart });
        getTotalAmount();
        getToyUnitsQ();
        toast.error(`${theToy.name} borrado del carrito de compras`, {
          position: "bottom-left",
        });
        return;
      },
      updateCartItemQ: async (toyId, newQuantity) => {
        let cartItems = get().cart;
        let theToyArray = cartItems.filter(item => item.id == toyId)
        console.log(theToyArray)
        let getToyUnitsQ = get().getToyUnitsQ;
        let getTotalAmount = get().getTotalAmount;
        for (let i = 0; i < cartItems.length; i++) {
          if (cartItems[i].id === Number(toyId)) {
            cartItems[i].quantity = Number(newQuantity);
          }
        }
        set({ cart: cartItems });
        getTotalAmount();
        getToyUnitsQ();
        toast.info(
            `${newQuantity} ${theToyArray[0].name} en el carrito de compras`,{
              position: "bottom-left"}
          );
        return;
      },
      clearStore: () => {
        return set({
          cart: [],
          totalAmount: 0,
          toyUnitsQ: 0,
        });
      },
    }),
    {
      name: "cart",
      storage: createJSONStorage(() => localStorage),
    }
  )
);
